var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 468873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.36021 0.915039C7.49484 1.83266 7.92158 2.68247 8.57717 3.33848C9.23276 3.99449 10.0823 4.42178 10.9998 4.55699C10.0823 4.69137 9.23267 5.11808 8.57699 5.77376C7.9213 6.42945 7.49459 7.27912 7.36021 8.19661C7.225 7.27908 6.79771 6.42954 6.1417 5.77395C5.48569 5.11836 4.63588 4.69162 3.71826 4.55699C4.63593 4.42153 5.4856 3.99421 6.14152 3.33829C6.79743 2.68237 7.22475 1.8327 7.36021 0.915039Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.70658 0C1.77049 0.431078 1.97136 0.83017 2.27951 1.13832C2.58766 1.44647 2.98675 1.64734 3.41783 1.71125C2.98675 1.77516 2.58766 1.97603 2.27951 2.28418C1.97136 2.59233 1.77049 2.99142 1.70658 3.4225C1.64292 2.99209 1.44274 2.5935 1.13551 2.28543C0.828272 1.97736 0.430231 1.77608 0 1.71125C0.430231 1.64642 0.828272 1.44514 1.13551 1.13707C1.44274 0.828997 1.64292 0.430406 1.70658 0Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 8.49553C1.62984 8.40527 2.21346 8.11329 2.66338 7.66338C3.11329 7.21346 3.40527 6.62984 3.49553 6C3.58902 6.63002 3.88319 7.21309 4.33436 7.66265C4.78553 8.11221 5.36965 8.40429 6 8.49553C5.36947 8.58997 4.78589 8.88424 4.33506 9.33506C3.88424 9.78589 3.58997 10.3695 3.49553 11C3.40429 10.3697 3.11221 9.78553 2.66265 9.33436C2.21309 8.88319 1.63002 8.58902 1 8.49553Z",
    fill: "#636363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.ebbb25b1815ab10bc7c52782cdc6a2a7.svg";
export { ForwardRef as ReactComponent };